if (!customElements.get('lusso-manifesto')) {
  customElements.define(
    'lusso-manifesto',
    class LussoManifesto extends HTMLElement {
      connectedCallback() {
        this.desktopMedia = window.matchMedia('(min-width: 990px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const video = this.querySelector('.ls-manifesto__video');
        if (video) {
          video.muted = true;
          this.videoObserver = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && !this.reducedMotion.matches) video.play().catch(() => {});
            else video.pause();
          }, {threshold:0.15});
          this.videoObserver.observe(video);
        }
        this.frame = null;
        this.revealObserver = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              this.classList.add('is-story-visible');
              this.revealObserver.disconnect();
            }
          },
          { threshold: 0.22 },
        );

        this.handleScroll = () => this.requestUpdate();
        this.handleResize = () => this.configure();
        this.handlePreference = () => this.configure();

        window.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener('resize', this.handleResize, { passive: true });
        this.desktopMedia.addEventListener?.('change', this.handlePreference);
        this.reducedMotion.addEventListener?.('change', this.handlePreference);

        this.configure();
        this.revealObserver.observe(this);
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
        this.desktopMedia?.removeEventListener?.('change', this.handlePreference);
        this.reducedMotion?.removeEventListener?.('change', this.handlePreference);
        if (this.frame) window.cancelAnimationFrame(this.frame);
        this.revealObserver?.disconnect();
        this.videoObserver?.disconnect();
      }

      get canEnhance() {
        return (
          this.dataset.scrollMode === 'sticky' &&
          this.desktopMedia.matches &&
          !this.reducedMotion.matches &&
          document.body?.dataset.lussoMotion !== 'off'
        );
      }

      configure() {
        const enabled = this.canEnhance;
        this.classList.toggle('is-scroll-enhanced', enabled);
        if (enabled) {
          this.requestUpdate();
        } else {
          if (this.frame) window.cancelAnimationFrame(this.frame);
          this.frame = null;
          this.setProgress(1);
        }
      }

      requestUpdate() {
        if (!this.canEnhance || this.frame) return;
        this.frame = window.requestAnimationFrame(() => {
          if (!this.canEnhance) {
            this.frame = null;
            return;
          }
          const rect = this.getBoundingClientRect();
          const travel = Math.max(1, this.offsetHeight - window.innerHeight);
          const progress = Math.min(1, Math.max(0, -rect.top / travel));
          this.setProgress(progress);
          this.frame = null;
        });
      }

      setProgress(progress) {
        const mask = (1 - progress) * 8;
        const primaryScale = 1.055 - progress * 0.055;
        const detailShift = 8 - progress * 13;
        const copyShift = 4 - progress * 4;
        const copyOpacity = 0.72 + progress * 0.28;

        this.style.setProperty('--ls-manifesto-progress', progress.toFixed(4));
        this.style.setProperty('--ls-manifesto-mask', `${mask.toFixed(3)}%`);
        this.style.setProperty('--ls-manifesto-primary-scale', primaryScale.toFixed(4));
        this.style.setProperty('--ls-manifesto-detail-shift', `${detailShift.toFixed(3)}rem`);
        this.style.setProperty('--ls-manifesto-copy-shift', `${copyShift.toFixed(3)}rem`);
        this.style.setProperty('--ls-manifesto-copy-opacity', copyOpacity.toFixed(4));
      }
    },
  );
}
